export const PUSH_NEW_ROUTE = "PUSH_NEW_ROUTE";
export type PUSH_NEW_ROUTE = typeof PUSH_NEW_ROUTE;


// WEBPACK FOOTER //
// ./src/store/Routing/constants.ts